"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiHelpCircle = function IconUiHelpCircle(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M27.663 15.921a5.164 5.164 0 0 0-3.7-1.521 5.075 5.075 0 0 0-3.711 1.533 5.194 5.194 0 0 0-1.434 2.595l-.213.978 1.954.427.213-.977a3.19 3.19 0 0 1 .894-1.609 3.1 3.1 0 0 1 2.3-.947 3.171 3.171 0 0 1 2.3.946 3.033 3.033 0 0 1 .869 1.66 2.245 2.245 0 0 1 .078.6 3.162 3.162 0 0 1-.9 2.25 1.734 1.734 0 0 0-.249.243c-.1.081-.187.162-.271.244l-1.233.943a4.029 4.029 0 0 0-1.59 2.614 5.876 5.876 0 0 0-.045.724v1.939h2v-1.936a3.812 3.812 0 0 1 .025-.441 2.043 2.043 0 0 1 .821-1.318l1.277-.976.1-.089a3.05 3.05 0 0 1 .254-.226l.28-.271a5.16 5.16 0 0 0 1.522-3.7 4 4 0 0 0-.13-1.046 4.968 4.968 0 0 0-1.411-2.639z"
  }), _react.default.createElement("path", {
    d: "M24-.023A24.023 24.023 0 1 0 48.023 24 24.05 24.05 0 0 0 24-.023zm0 46.046A22.023 22.023 0 1 1 46.023 24 22.047 22.047 0 0 1 24 46.023z"
  }), _react.default.createElement("path", {
    d: "M23.925 31.8a1.6 1.6 0 1 0 1.6 1.6 1.6 1.6 0 0 0-1.6-1.6z"
  }));
};

IconUiHelpCircle.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiHelpCircle;
exports.default = _default;